
export const ASSET_ACTIONS = {
	FETCH_TOTAL_ASSETS: "FETCH_TOTAL_ASSETS",
	FETCH_TOTAL_ASSETS_SUCCESS: "FETCH_TOTAL_ASSETS_SUCCESS",
	FETCH_TOTAL_ASSETS_ERROR: "FETCH_TOTAL_ASSETS_ERROR",

	RESET_ASSETS_LIST: "RESET_ASSETS_LIST",
	LOAD_ASSETS_AJAX: "LOAD_ASSETS_AJAX",
	LOAD_ASSETS_SUCCESS: "LOAD_ASSETS_SUCCESS",
	LOAD_ASSETS_ERROR: "LOAD_ASSETS_ERROR",
	LOAD_ASSETS_CANCEL: "LOAD_ASSETS_CANCEL",

	FETCH_ASSET_DETAIL: "FETCH_ASSET_DETAIL",
	FETCH_ASSET_DETAIL_SUCCESS: "FETCH_ASSET_DETAIL_SUCCESS",
	FETCH_ASSET_DETAIL_ERROR: "FETCH_ASSET_DETAIL_ERROR",

	LOAD_CREATIVES_DISTINCTS_AJAX:    "LOAD_CREATIVES_DISTINCTS_AJAX",
	LOAD_CREATIVES_DISTINCTS_SUCCESS: "LOAD_CREATIVES_DISTINCTS_SUCCESS",
	LOAD_CREATIVES_DISTINCTS_ERROR:   "LOAD_CREATIVES_DISTINCTS_ERROR",

	CHANGE_ASSET_TYPE_FILTER:"CHANGE_ASSET_TYPE_FILTER",

	DELETE_VERSIONS_AJAX:"DELETE_VERSIONS_SUCCESS",
	DELETE_VERSIONS_SUCCESS:"DELETE_VERSIONS_SUCCESS",
	DELETE_VERSIONS_ERROR:"DELETE_VERSIONS_ERROR",

	UPLOAD_ASSETS_AJAX: "UPLOAD_ASSETS_AJAX",
	UPLOAD_ASSETS_SUCCESS: "UPLOAD_ASSETS_SUCCESS",
	UPLOAD_ASSETS_ERROR: "UPLOAD_ASSETS_ERROR",

	FETCH_ASSET_LINKED_CREATIVES_AJAX:    "FETCH_ASSET_LINKED_CREATIVES_AJAX",
	FETCH_ASSET_LINKED_CREATIVES_SUCCESS: "FETCH_ASSET_LINKED_CREATIVES_SUCCESS",
	FETCH_ASSET_LINKED_CREATIVES_ERROR:   "FETCH_ASSET_LINKED_CREATIVES_ERROR",
	CLEAR_ASSET_LINKED_CREATIVES:        "CLEAR_ASSET_LINKED_CREATIVES",

	FETCH_ASSET_DYNAMIC_VARIABLES_AJAX: "FETCH_ASSET_DYNAMIC_VARIABLES_AJAX",
	FETCH_ASSET_DYNAMIC_VARIABLES_SUCCESS: "FETCH_ASSET_DYNAMIC_VARIABLES_SUCCESS",
	FETCH_ASSET_DYNAMIC_VARIABLES_ERROR: "FETCH_ASSET_DYNAMIC_VARIABLES_ERROR",
	CLEAR_ASSET_DYNAMIC_VARIABLES: "CLEAR_ASSET_DYNAMIC_VARIABLES",

	TRANSCODE_VIDEO_AJAX: "TRANSCODE_VIDEO_AJAX",
	TRANSCODE_VIDEO_SUCCESS: "TRANSCODE_VIDEO_SUCCESS",
	TRANSCODE_VIDEO_ERROR: "TRANSCODE_VIDEO_ERROR",

	DELETE_ASSET_AJAX:"DELETE_ASSET_AJAX",
	DELETE_ASSET_SUCCESS:"DELETE_ASSET_SUCCESS",
	DELETE_ASSET_ERROR:"DELETE_ASSET_ERROR",

	ADD_SOCKET_ASSET_ITEM:"ADD_SOCKET_ASSET_ITEM",
	ADD_SOCKET_ASSET_ITEMS:"ADD_SOCKET_ASSET_ITEMS",

	FETCH_ASSET_NAME_CONFLICTS_AJAX: "FETCH_ASSET_NAME_CONFLICTS_AJAX",
	FETCH_ASSET_NAME_CONFLICTS_SUCCESS: "FETCH_ASSET_NAME_CONFLICTS_SUCCESS",
	FETCH_ASSET_NAME_CONFLICTS_ERROR: "FETCH_ASSET_NAME_CONFLICTS_ERROR",


	DOWNLOAD_ASSETS_AJAX: "DOWNLOAD_ASSETS_AJAX",
	DOWNLOAD_ASSETS_SUCCESS: "DOWNLOAD_ASSETS_SUCCESS",
	DOWNLOAD_ASSETS_ERROR: "DOWNLOAD_ASSETS_ERROR",
};
